import http from '@/utils/http'

export default {
  async getJsApiSignature(options) {
    return await http.get('/api/wx/getJsSign', options)
  }
}
